import { setFocusOnField } from '@/core/core_components/form/form'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { initDataInTextInput } from '@/core/item_assistance/initializeComponentData'
import { getDataFromTextInput } from '@/core/item_assistance/receiveDataFromComponents'
import { importLauncher } from '@/core/migration/ImportManager'
import { Progress } from '@/core/input_controls/fileUploader/imageUploader'

export function MigrationResourceManager (companyId) {
	'use strict'

	this.companyId = companyId

	this.action = undefined
	this.migrationResourceId = undefined
	this.migrationResourceIds = undefined
	this.activeAttribute = undefined
	this.fields = undefined
	this.prefix = undefined
	this.postSaveAction = undefined
	this.postRemoveAction = undefined
	this.postUploadAction = undefined

	this.setProperties = function (properties) {
		this.action = properties.action || 'create'
		this.migrationResourceId = properties.migrationResourceId || undefined
		this.migrationResourceIds = properties.migrationResourceIds || undefined
		this.activeAttribute = properties.activeAttribute || undefined
		this.fields = properties.fields || ['name', 'type', 'comment']
		this.prefix = properties.prefix || 'migration-resource_'
		this.postSaveAction = properties.postSaveAction
		this.postRemoveAction = properties.postRemoveAction
		this.postUploadAction = properties.postUploadAction
	}

	this.initPage = function (migrationResource) {
		var manager = this
		this.resetFields()

		manager.setMigrationResourceInformation(migrationResource)
		setFocusOnField(manager.activeAttribute)
	}

	this.updateMigrationResource = function (migrationResourceInformation) {
		var manager = this
		var url = manager.formatUrl('update')

		$.ajax({
			url: url,
			type: 'POST',
			data: JSON.stringify(migrationResourceInformation),
			contentType: 'application/json; charset=UTF-8',

			success: function () {
				if (manager.postSaveAction) {
					manager.postSaveAction()
				}
				showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.saving'), 'danger')
			}
		})
	}

	this.removeMigrationResource = function () {
		var manager = this
		var url = manager.formatUrl('remove')
		$.ajax({
			type: 'POST',
			url: url,
			data: {
				ids: JSON.stringify(manager.migrationResourceIds)
			},
			success: function () {
				if (manager.postRemoveAction) {
					manager.postRemoveAction()
				}
				showMessageAlert(getLocalizedMessage('removed.configuration.resource'), 'success')
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.remove.configuration.resource'), 'danger')
			}
		})
	}

	this.formatUrl = function (action) {
		var dataCategory = (companyId == null ? 'global' : 'company')
		return window.urlContext + dataCategory + '/migration-resources/' + action
	}

	this.showPasswordError = function (message) {
		showMessageAlert(showMessageAlert('error'), 'danger')
	}

	this.setMigrationResourceInformation = function (data) {
		var manager = this
		_.each(data, function (value, key) {
			initDataInTextInput(manager.prefix + key, value)
		})

		$('#migration-resource_name').prop('readonly', true)
		$('#migration-resource_type').prop('disabled', 'disabled')

		var name = data['name']
		var type = data['type'].toLowerCase()
		var dataCategory = (manager.companyId == null) ? 'global' : 'company'
		var link = manager.formatUrl(type) + '?name=' + name

		var html = ''
		if (type == 'image') {
			html += '<img src="' + link + '"/><br/>'
		}
		html += '<a href="' + link + '" data-category="' + dataCategory + '" tabindex="-1">' + name + '</a>'
		$('#resource-info').html(html)
	}

	this.resetFields = function () {
		var manager = this
		_.each(this.fields, function (field) {
			initDataInTextInput(manager.prefix + field, '')
		})
	}

	this.getMigrationResourceInformation = function () {
		var manager = this

		var migrationResourceInformation = {}
		if (this.action == 'edit') {
			migrationResourceInformation['id'] = this.migrationResourceId
		}

		_.each(this.fields, function (field) {
			migrationResourceInformation[field] = getDataFromTextInput(manager.prefix + field)
		})

		return migrationResourceInformation
	}

	this.updateData = function (table) {
		table.initTable()
		table.selectedItemsManager.clearSelections(table)
	}

	this.loadData = function (table) {
		var url = this.formatUrl('load')
		$.ajax({
			type: 'GET',
			url: url,
			async: false,

			success: function () {
				showMessageAlert(getLocalizedMessage('loaded.configuration.resources'), 'success')
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.loading.configuration.resources'), 'danger')
			}
		})

		this.updateData(table)
	}

	this.initMigrationResourceManager = function (action, migrationResource, activeAttribute, table) {
		var manager = this

		Swal.fire({
			title: getLocalizedMessage('configuration.resources'),
			html: '<div class="modal_item">\n' +
				'    <label for="migration-resource_name">' + getLocalizedMessage('configuration.resource.name') + '</label>\n' +
				'    <br>\n' +
				'    <input id="migration-resource_name" class="textInput attribute-editor" type="text">\n' +
				'</div>\n' +
				'\n' +
				'<div class="modal_item">\n' +
				'    <label for="migration-resource_type">' + getLocalizedMessage('configuration.resource.type') + '</label>\n' +
				'    <br>\n' +
				'    <select id="migration-resource_type" class="select attribute-editor">\n' +
				'        <option value="XSLT">XSLT</option>\n' +
				'        <option value="IMAGE">IMAGE</option>\n' +
				'        <option value="EXCEL">EXCEL</option>\n' +
				'        <option value="XML">XML</option>\n' +
				'        <option value="CSV">CSV</option>\n' +
				'        <option value="ZIP">ZIP</option>\n' +
				'    </select>\n' +
				'</div>\n' +
				'\n' +
				'<div class="modal_item">\n' +
				'    <label for="migration-resource_comment">' + getLocalizedMessage('configuration.resource.comment') + '</label>\n' +
				'    <br>\n' +
				'    <textarea id="migration-resource_comment" class="textarea attribute-editor"></textarea>\n' +
				'    <button class="button_reset single-area-reset fa fa-times"></button>\n' +
				'</div>\n' +
				'\n' +
				'<div class="modal_item card-container">\n' +
				'    <label for="resource-info">' + getLocalizedMessage('configuration.resource.file') + '</label>\n' +
				'    <br>\n' +
				'    <div id="resource-info">\n' +
				'    </div>\n' +
				'</div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				content: 'form',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					action: action,
					migrationResourceId: migrationResource['id'],
					activeAttribute: activeAttribute,
					postSaveAction: function () {
						manager.updateData(table)
					}
				})
				manager.initPage(migrationResource)
			},
			preConfirm: function (inputValue) {
				return manager.getMigrationResourceInformation()
			}
		}).then(function (result) {
			if (result.value) {
				manager.updateMigrationResource(result.value)
			}
		})
	}

	this.initRemoveMigrationResource = function (migrationResource, table) {
		var manager = this

		Swal.fire({
			title: getLocalizedMessage('remove.configuration.resource.confirmation'),
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					action: 'remove',
					migrationResourceIds: [migrationResource['id']],
					postRemoveAction: function () {
						manager.updateData(table)
					}
				})
			}
		}).then(function (result) {
			if (result.value) {
				manager.removeMigrationResource()
			}
		})
	}

	this.initMultipleRemoveMigrationResource = function (ids, table) {
		var manager = this

		Swal.fire({
			title: getLocalizedMessage('remove.configuration.resource.confirmation'),
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					action: 'remove',
					migrationResourceIds: ids,
					postRemoveAction: function () {
						manager.updateData(table)
					}
				})
			}
		}).then(function (result) {
			if (result.value) {
				manager.removeMigrationResource()
			}
		})
	}

	this.initUploadMigrationResource = function (table) {
		var manager = this

		Swal.fire({
			title: getLocalizedMessage('configuration.resources'),
			html: '<div class="resource-uploader-block modal_item">\n' +
				'        <label>' + getLocalizedMessage('upload.file') + '</label>\n' +
				'              <input type="file" id="add_resources" class="resource-uploader" accept=".xsl,.jpg,.jpeg,.png,.xlsx,.xls,.xml,.csv,.zip" multiple>\n' +
				'              <div id="upload-resource-progress" class="hidden-element resource-block">\n' +
				'                  <progress></progress>\n' +
				'                  <span class="progress-percent"></span>\n' +
				'                  <button class="button_reset fa fa-times"></button>\n' +
				'              </div>\n' +
				'          </div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				content: 'form',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					postUploadAction: function () {
						manager.updateData(table)
						Swal.close()
					}
				})
				manager.initUploadPage()
			},
			preConfirm: function (inputValue) {

			}
		}).then(function (result) {
			if (result.value) {

			}
		})
	}

	this.initUploadPage = function () {
		var manager = this

		var resourceUploaderSelector = $('.resource-uploader')
		resourceUploaderSelector.unbind('change')
		resourceUploaderSelector.change(function () {
			manager.uploadMigrationResources()
		})

		$('.resource-uploader-block .form-group-name').remove()
	}

	this.uploadMigrationResources = function () {
		var manager = this

		var files = $('#add_resources').get(0).files
		var resourceFiles = new FormData()
		var permitted = false

		if (files) {
			_.each(files, function (file) {
				resourceFiles.append('source', file)
				permitted = true
			})

			if (permitted) {
				var url = manager.formatUrl('create')
				var $uploadProgress = $('#upload-resource-progress')
				$uploadProgress.removeClass('hidden-element')
				var progress = new Progress($uploadProgress)
				var xhr = $.ajaxSettings.xhr()

				$.ajax({
					type: 'POST',
					url: url,
					data: resourceFiles,
					cache: false,
					contentType: false,
					processData: false,
					context: this,

					xhr: function () {
						xhr.upload.addEventListener('progress', progress.progressHandlingFunction, false)
						return xhr
					},

					beforeSend: function () {
						progress.bindCancelButton(xhr, '.button_reset', function () {
							importLauncher.launched = false
							$uploadProgress.addClass('hidden-element')
						})
					},

					success: function () {
						var $addControl = $('#add_resources').val('')
						$addControl.closest('.resource-uploader-block').find('.form-control').val('')
						$uploadProgress.addClass('hidden-element')

						if (manager.postUploadAction) {
							manager.postUploadAction()
						}
						showMessageAlert(getLocalizedMessage('success'), 'success')
					},

					error: function () {
						$uploadProgress.addClass('hidden-element')
						showMessageAlert(getLocalizedMessage('error'), 'danger', getLocalizedMessage('error.loading.file'))
					}
				})
			} else {
				var $addControl = $('#add_resources').val('')
				$addControl.closest(".resource-uploader-block").find(".form-control").val("");
			}
		}
	};
}
